
const AITrip = () => {
  return (
    <div className="w-full">
      <iframe
        className="w-full" style={{ minHeight: 400, border: 0, height: '100vh' }}
        src="https://lc-xc.cookieboty.tech/"
        title="AI Trip"
      />
    </div>
  )
}

export default AITrip